module.exports = __webpack_public_path__ + "img/loading-5.04bdf8f9.gif";